import React, { useState, forwardRef, useImperativeHandle } from 'react';
import '../../styles/projects/projects.css';
import { ReactComponent as HandshakeIcon } from '../../assets/svg/handshake.svg';

const WP5 = forwardRef((props, ref) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const sectionRef = React.useRef(null);

	const toggleExpand = () => {
		setIsExpanded(!isExpanded);
	};

	useImperativeHandle(ref, () => ({
		expandSection() {
			if (sectionRef.current) {
				const yOffset = -100; 
				const y = sectionRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
				window.scrollTo({ top: y, behavior: 'smooth' });
				setTimeout(() => {
					setIsExpanded(true);
				}, 470); 
			}
		},
	}));

	const leaders = [
		{ name: 'Prof. Janne Lehtiö (KI)', link: 'https://ki.se/en/people/janne-lehtio' },
		{ name: 'Helena Bäckvall (KI)', link: 'https://ki.se/personer/helena-backvall' },
		{ name: 'Xenia Villalobos Alberú', link: 'https://ki.se/en/people/xenia-villalobos-alberu' },
	];

	const [lead1, lead2, ...participants] = leaders;
	const renderPerson = (person, key) =>
		person.link ? (
			<a key={key} href={person.link} target="_blank" rel="noopener noreferrer">
				{person.name}
			</a>
		) : (
			<span key={key}>{person.name}</span>
		);
	
	return (
		<section className="WPinfo" ref={sectionRef}>
			<span className='wpinfo-icon'>
				<HandshakeIcon />
			</span>
			<span className="WPinfo-body">
				<h2>Work package 5: Organisation, management and coordination</h2>
				<p>
					<strong>Led by:</strong>{' '}
					{renderPerson(lead1, 'lead1')} <em>and</em> {renderPerson(lead2, 'lead2')}
				</p>

				{participants.length > 0 && (
					<p>
						<strong>Participants:</strong>{' '}
						{participants.map((p, i) => (
						<React.Fragment key={i}>
							{renderPerson(p, i)}
							{i < participants.length - 1 ? ', ' : ''}
						</React.Fragment>
						))}
						.
					</p>
				)}
				<div className={`expandable-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
					WP5 ensures the smooth operation and long-term sustainability of the project. A dedicated management group oversees planning, 
					monitoring, evaluation, and risk management, while fostering dialogue across partners and with key stakeholders such as industry, 
					national authorities, and international initiatives. This work package also manages communication, reporting, and outreach 
					activities, aligning the project within the broader precision medicine ecosystem. Beyond day-to-day coordination, WP5 plays a 
					central role in securing future funding and positioning the initiative as a world-leading environment for clinical 
					proteomics innovation. 
				</div>
				<button className="read-more-btn" onClick={toggleExpand}>
					{isExpanded ? 'Show Less' : 'Read More'}
				</button>
			</span>
		</section>
	);
});

export default WP5;
